/**
 * @generated SignedSource<<3d04ffc5fa89e2e7ed7515cfa799e33e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionStatusCircle_RoutineOccasion$data = {
  readonly deadlineAt: string | null;
  readonly expireAt: string;
  readonly startAt: string;
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentType": "RoutineOccasionStatusCircle_RoutineOccasion";
};
export type RoutineOccasionStatusCircle_RoutineOccasion$key = {
  readonly " $data"?: RoutineOccasionStatusCircle_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionStatusCircle_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "725374a014d9337d5cb3d94053225cc4";

export default node;
